<template>
  <div>
    <b-alert show v-if="displayMaintenanceWindow" variant="warning">
      <h4 class="alert-heading"><strong>Geplantes Wartungsfenster</strong></h4>
      <p class="mb-0">
        <strong>Am 30.01.2024 von 20:00 Uhr bis voraussichtlich 21:00 Uhr wird das eFörderportal nicht zur Verfügung stehen. Danke für Ihr Verständnis.</strong>
      </p>
    </b-alert>
    <permission-accept />
    <a v-intro="'<strong>Rundgang</strong><br><br>Klicken Sie durch den kurzen Rundgang und erhalten Sie einen schnellen Überblick. Den Überblick finden Sie auch unter Hilfe.'" v-intro-step="1" v-intro-position="'right'"></a>
    <notification />
    <button-group />
    <application-draft-list/>
    <!--<draft-list />
    <application-list />-->
    <side-bar />
  </div>
</template>

<script>
  import { errorHandler } from '@/helpers/formHelper.js'
  import PermissionAccept from '@/components/permission/PermissionAccept.vue'
  import Notification from '@/components/overview/Notification.vue'
  import ButtonGroup from '@/components/overview/ButtonGroup.vue'
  // import ApplicationList from '@/components/overview/ApplicationList.vue'
  // import DraftList from '@/components/overview/DraftList.vue'
  import SideBar from '@/components/permission/SideBar.vue'
  import ApplicationDraftList from '@/components/overview/ApplicationDraftList.vue'

  export default {
    components: {
      PermissionAccept,
      Notification,
      // ApplicationList,
      ButtonGroup,
      // DraftList,
      SideBar,
      ApplicationDraftList
    },
    data: () => ({
      introStatus: undefined
    }),
    created () {
      this.getIntroDisplayedStatus()
    },
    methods: {
      async getIntroDisplayedStatus () {
        this.$store.dispatch('intro/GET_INTRO_DISPLAYED').then(res => {
          const { data, errors } = res

          if (errors) {
            return errorHandler(this, errors)
          }

          this.introStatus = data.userHasIntroDisplayed.introDisplayed
          const windowWidth = window.innerWidth

          if (windowWidth >= 993 && this.introStatus === false) {
            this.startIntro()
          }
        }).catch(err => {
          console.error(err)
        })
      },
      startIntro () {
        this.$intro().setOptions({
          keyboardNavigation: true,
          exitOnOverlayClick: false,
          skipLabel: 'Rundgang beenden',
          doneLabel: 'Rundgang beenden',
          prevLabel: 'Zurück',
          nextLabel: 'Weiter'
        })
          .start()
          .oncomplete(() => {
            this.updateIntroDisplayedStatus()
          })
          .onexit(() => {
            this.updateIntroDisplayedStatus()
          })
      },
      async updateIntroDisplayedStatus () {
        this.$store.dispatch('intro/UPDATE_INTRO_DISPLAYED').then(res => {
          const { errors } = res

          if (errors) {
            console.error(errors)
          }
          this.introStatus = res.data.userSetIntroDisplayed.ok
        }).catch(err => {
          console.error(err)
        })
      }
    },
    computed: {
      displayMaintenanceWindow () {
        const currentDateTime = new Date()
        const endMaintenance = new Date(2024, 0, 30, 21, 0, 0)
        let showWindow = false
        if (currentDateTime < endMaintenance) {
          showWindow = true
        }
        return showWindow
      }
    }
  }
</script>
